<div id="trademarkspiediv" #trademarkspiediv class="trademarks-pie" [style.height.px]="height"></div>